export enum ReservationStatusEnum {
  Pending = 1,
  Approved,
  Declined,
  Canceled
}
